import axios from "../utility/authAxios";
import { API_VERSION, SAAS_SERVICE_PATH } from "../config/axios";

const url = `${API_VERSION}/${SAAS_SERVICE_PATH}/location`;

/**************** Station API *****************************/
/**
 * get all station
 * @param params => {orderBy, sortBy, pageOffset, page, search}
 * @returns {Promise<AxiosResponse<any>>}
 */

export const getDistricts = async () => {
    return axios.get(`${url}/districts`);
};

export const getUpazilas = async () => {
    return axios.get(`${url}/upazilas`);
};
export const getUpazilasByDistrictId = async (id) => {
    return axios.get(`${url}/upazilas/${id}`);
};
export const remove = async (id) => {
    return axios.delete(`${url}/${id}`);
};

export const getCountries= async () => {
    return axios.get(`${url}/countries`);
};
